export const getNewEmployer = (employer, agentCode) => {
  return {
    ...employer,
    agents: employer.agents.filter(agent => agent.agentCode !== agentCode),
  };
};
